import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import numeral from 'numeral';
import { css } from '@bd/bdui-styles/emotion';
import { Image, GoogleMapUrl } from '@bd/bdcore-utilities';
import { Link } from '@bd/bdcore-named-routes';
import withData from '@bd/bdcore-data';
import { ActivateMapPin } from '@bd/bdcore-data/build/Map';
import { FavoriteToggle } from './Favorites';
import { colors, typography } from '../styles';
import CompareButton from './CompareButton';

const styles = css`
  width: calc(100% - 30px);
  margin: 0 15px 30px 15px;
  @media (min-width: 480px) {
    width: 340px;
    max-width: 340px;
  }
  .CommunityCard_wrapper {
    display: flex;
    background: ${colors.white};
    box-shadow: 0 10px 15px 0 rgba(0,0,0,0.05);
    transition: all .3s ease;
    &:hover {
      transform: scale(1.02);
      box-shadow: 0 10px 15px 0 rgba(0,0,0,0.15);
    }
  }
  .CommunityCard_inner {
    width: 100%;
    background-color: ${colors.white};
  }
  .CommunityCard_media {
    position: relative;
  }
  .CommunityCard_image {
    width: 100%;
    height: auto;
  }
  .CommunityCard_content {
    padding: 20px;
    position: relative;
  }
  .CommunityCard_name {
    margin: 0 0 12px 0;
    font-size: 20px;
    line-height: .8;
    font-weight: 700;
    color: ${colors.brand1};
    a {
      color: ${colors.brand1};
    }
  }
  .CommunityCard_city {
    margin: 0 0 0 0;
    font-size: 15px;
    font-weight: 700;
    font-family: ${typography.Condensed};
    text-transform: uppercase;
    color: ${colors.brand1};
    a {
      color: ${colors.brand1};
    }
  }
  .CommunityCard_iconList {
    display: flex;
    list-style: none;
    margin: 12px 0;
    padding: 0;
  }
  .CommunityCard_iconListItem {
    text-align: center;
    font-size: 15px;
    font-weight: 300;
    font-family: ${typography.Condensed};
    margin: 0 12px 0 0;
  }
  .CommunityCard_iconListIcon {
    margin: 0 0 4px 0;
    display: none;
  }
  .CommunityCard_iconListValue {
    font-weight: 700;
    margin: 0 3px 0 0;
  }
  .CommunityCard_linkIcon {
    width: 13px;
    height: 13px;
    margin: 5px 0 0 0;
  }
  .CommunityCard_mapButton {
    width: 23px;
    height: 31px;
    position: absolute;
    top: 20px;
    right: 20px;
    display: block;
  }
  .CommunityCard_detailButton {
    height: 40px;
    width: 40px;
    border-radius: 5px;
    background-color: ${colors.brand3};
    background-image: url('/images/icon-arrow-right-white.svg');
    background-position: center center;
    background-repeat: no-repeat;
    position: absolute;
    right: 20px;
    bottom: 20px;
    z-index: 2;
    pointer-events: none;
  }
  .CommunityCard_list1 {
    list-style: none;
    margin: 0 -20px;
    border-top: 1px solid ${colors.neutral};
    border-bottom: 1px solid ${colors.neutral};
    padding: 0 20px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
  }
  .CommunityCard_priceWrapper {
    padding: 12px 0;
  }
  .CommunityCard_priceValue {
    font-size: 18px;
    line-height: 1;
    margin: 0;
    font-family: ${typography.Condensed};
    color: ${colors.body};
  }
  .CommunityCard_status {
    font-size: 15px;
    line-height: 1;
    font-weight: 700;
    font-family: ${typography.Condensed};
  }
  .CommunityCard_list2 {
    list-style: none;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    padding: 12px 0 0 0;
    margin: 0;
  }
  .CommunityCard_list2Item {
    font-size: 15px;
    line-height: 1.2;
    &:first-child {
      width: 60%;
    }
    a {
      font-weight: 700;
    }
  }
`;

function CommunityCardVertical({ community }) {
  return (
    <div className={styles}>
      <ActivateMapPin hover itemId={get(community, '_id')}>
        <div className="CommunityCard_wrapper">
          <div className="CommunityCard_inner">
            <div className="CommunityCard_media">
              <Link name="community-detail" community={community}>
                <Image
                  className="CommunityCard_image"
                  src={get(community, 'photos[0].contentUrl')}
                  alt={get(community, 'photos[0].name', get(community, 'photos[0].caption', ''))}
                  width={600}
                  height={380}
                  exact
                />
              </Link>
              <div className="CommunityCard_detailButton" />
              <FavoriteToggle community={community} />
            </div>
            <div className="CommunityCard_content">
              <h4 className="CommunityCard_name">
                <Link name="community-detail" community={community}>
                  {get(community, 'name')}<br />
                  <span className="CommunityCard_city">{get(community, 'address.addressLocality')}, {get(community, 'address.addressRegion')} {get(community, 'address.postalCode')}</span>
                </Link>
              </h4>
              <a href={GoogleMapUrl(community)} target="_blank" rel="noopener noreferrer" className="CommunityCard_mapButton">
                <img src="/images/icon-map-pin-brand2.svg" alt="Open in Google Maps" />
              </a>
              {/* <ul className="CommunityCard_iconList">
                {
                  get(home, 'beds') &&
                  <li className="CommunityCard_iconListItem">
                    <span className="CommunityCard_iconListIcon">
                    <img src="/images/icon-beds.svg" alt="" /></span>
                    <span className="CommunityCard_iconListValue">{get(home, 'beds')}</span>
                    <span className="CommunityCard_iconListLabel">Beds</span>
                  </li>
                }
                {
                  get(home, 'bathsFull') &&
                  <li className="CommunityCard_iconListItem">
                    <span className="CommunityCard_iconListIcon">
                    <img src="/images/icon-baths.svg" alt="" /></span>
                    <span className="CommunityCard_iconListValue">
                      {get(home, 'bathsFull')} {get(home, 'bathsHalf', 0) > 0 && '.5'}
                    </span>
                    <span className="CommunityCard_iconListLabel">Baths</span>
                  </li>
                }
                {
                  get(home, 'sqft') &&
                  <li className="CommunityCard_iconListItem">
                    <span className="CommunityCard_iconListIcon">
                    <img src="/images/icon-sqft.svg" alt="" /></span>
                    <span className="CommunityCard_iconListValue">
                    {numeral(get(home, 'sqft')).format('0,0')}</span>
                    <span className="CommunityCard_iconListLabel">SQ FT</span>
                  </li>
                }
              </ul> */}
              <ul className="CommunityCard_list1">
                {
                  get(community, 'priceLow') &&
                  <li className="CommunityCard_priceWrapper">
                    <span className="CommunityCard_priceValue">
                      <strong>Priced From </strong>
                      {numeral(get(community, 'priceLow')).format('$0,0')}&nbsp;
                      - {numeral(get(community, 'priceHigh')).format('$0,0')}
                    </span>
                  </li>
                }
              </ul>
              {
                get(community, 'schools[0].district') &&
                <ul className="CommunityCard_list2">
                  <li className="CommunityCard_list2Item">{get(community, 'schools[0].district')}</li>
                </ul>
              }
              <CompareButton
                limit={5}
                className="CommunityListCard_btnCompare"
                type="communities"
                id={community._id}
              />
            </div>
          </div>
        </div>
      </ActivateMapPin>
    </div>
  );
}

CommunityCardVertical.propTypes = {
  community: PropTypes.object,
};

CommunityCardVertical.defaultProps = {
  community: undefined,
};

export default withData(
  {
    community: true,
  },
  {
    required: {
      community: true,
    },
  },
)(CommunityCardVertical);



// WEBPACK FOOTER //
// ./src/components/CommunityCardVertical.js